var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.198,
    height: 36,
    viewBox: "0 0 25.198 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.2,
    y1: 0.164,
    x2: 0.803,
    y2: 0.862,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#777679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.223,
    y1: 0.132,
    x2: 0.799,
    y2: 0.86,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#777679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777679"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12258",
    "data-name": "Group 12258",
    transform: "translate(-192.13 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M10,24.193a3.679,3.679,0,0,1-2.782-.175,3.626,3.626,0,0,1-1.924-2A3.654,3.654,0,0,1,2.847,20.7a3.591,3.591,0,0,1-.89-2.616A3.615,3.615,0,0,1,.3,15.86a3.577,3.577,0,0,1,.311-2.742,3.581,3.581,0,0,1-.55-2.706A3.6,3.6,0,0,1,1.514,8.055,3.578,3.578,0,0,1,2.17,5.372,3.652,3.652,0,0,1,4.493,3.844a3.614,3.614,0,0,1,1.74-2.156,3.494,3.494,0,0,1,3.358-.173l.012,0A3.472,3.472,0,0,1,12.6,0a3.67,3.67,0,0,1,2.6,1.006,3.679,3.679,0,0,1,2.782.173,3.623,3.623,0,0,1,1.925,2A3.659,3.659,0,0,1,22.351,4.5a3.593,3.593,0,0,1,.891,2.616A3.619,3.619,0,0,1,24.9,9.339a3.578,3.578,0,0,1-.311,2.743,3.763,3.763,0,0,1-.9,5.063,3.582,3.582,0,0,1-.656,2.683A3.652,3.652,0,0,1,20.7,21.354a3.617,3.617,0,0,1-1.74,2.157,3.5,3.5,0,0,1-3.366.169,3.471,3.471,0,0,1-3,1.52A3.668,3.668,0,0,1,10,24.193Z",
    transform: "translate(192.131 8)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(195.731 11.6)",
    fill: "#f5f5f8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 6.6,
    cy: 6.6,
    r: 6.6,
    transform: "translate(198.131 14)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M16.8,12H16.63L12.6,10.22V2.387c.324-.086.643-.185.95-.292A6.943,6.943,0,0,0,16.8,0V12ZM.175,12H0V0A6.954,6.954,0,0,0,3.252,2.095c.3.106.621.2.948.292v7.834L.175,12ZM10.2,9.16h0l-1.8-.8-1.8.8V2.819a17.749,17.749,0,0,0,1.8.091,17.606,17.606,0,0,0,1.8-.091V9.159Z",
    transform: "translate(196.331 31.999)",
    fill: "#777679"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(201.13 24.001)",
    fill: "#f5f5f8",
    fontSize: 10,
    fontFamily: "GothamHTF-Bold, Gotham HTF",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverBadge);
export default __webpack_public_path__ + "static/media/silver-badge.89029e7c85507df0b586dbc608d7689b.svg";
export { ForwardRef as ReactComponent };